import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import Modal from '@material-ui/core/Modal';
import Picker from "emoji-picker-react";
import ModalHeading from './ModalHeading';
import { faSmile } from '@fortawesome/free-solid-svg-icons'

export default class EmojiItem extends Component {

	state = {
		open: false,
	};

	render() {
        const { passEmoji } = this.props;
        const { open } = this.state;
		return (
			<div>
	    	<Modal
				className="modal show"
				open={open}
				onClose={() => this.setState({open:false})}>
				<div className="modalBody modal-content" style={{width: '350px', maxHeight: '90%', overflow: 'auto'}}>
				<ModalHeading
							text={(
								<div>
                                   
							<FontAwesomeIcon  icon={faSmile} 
								style={{ marginRight: 5, color: COLORS.orange }} />
									<span>Feelings</span>
								</div>
							)}
							closeModal={() => this.setState({...this.state, open: false})}/>
					<div className="modalContent">
						<Picker onEmojiClick={(event, emojiObject) => {
							passEmoji(emojiObject.emoji)
						}} />
					</div>
				</div>
	      	</Modal>
		    <span
				className="link"
				onClick={() => this.setState({open:true})}
			>
					<FontAwesomeIcon icon={faSmile} size={"2x" } style={{ color: COLORS.orange }}  >
					</FontAwesomeIcon>
                   
        	</span>
		</div>
    );
	}
}



// WEBPACK FOOTER //
// ./src/components/EmojiButton.js